import { createAsyncThunk } from '@reduxjs/toolkit';

import { AtashsooziOmumiApiPaths } from 'Feature/Atashsoozi/Constant/AtashsooziOmumiApiPaths';
import { AtashsooziOmumiHttpGetService } from 'Feature/Atashsoozi/Services/AtashsooziHttpServices';

export const printElhaghiyehAtashsoozi = createAsyncThunk(
  'Atashsoozi/printElhaghiyehAtashsoozi',
  async (query: any) => {
    return await AtashsooziOmumiHttpGetService({
      url: `${AtashsooziOmumiApiPaths.BimehNameh.PrintElhaghiyehAtashsoozi}`,
      params: query,
      responseType: 'blob',
      isFile: true,
    });
  }
);

export const getElhaghiyehHayeSadereh = createAsyncThunk('Atashsoozi/getElhaghiyehHayeSadereh', async () => {
  return await AtashsooziOmumiHttpGetService({
    url: `${AtashsooziOmumiApiPaths.BimehNameh.GetElhaghiyehHayeSadereh}`,
  });
});
